module.exports = __webpack_public_path__ + "static/media/ZendyTitle.17e79fbb.png";